import cn from "classnames";

const ProgressDots = ({ total = 6, activeCount = 0 }) => {
  return (
    <div className="progress__dots">
      {[...Array(total)].map((_, index) => (
        <span
          key={index}
          className={cn({ active: index < activeCount })}
        ></span>
      ))}
    </div>
  );
};

export default ProgressDots;
